import React from 'react';
import { ComponentWithAs, forwardRef, Link, LinkProps, useDisclosure } from '@chakra-ui/react';
import { useRecoilValue } from 'recoil';
import { excludeCategories } from '../../../atoms/chooseState';
import ChooseDrawer from '../../choose/organism/ChooseDrawer';
// import ChooseModal from '../../choose/molecule/ChooseModal';

const FilterLink: ComponentWithAs<'a', LinkProps> = forwardRef<LinkProps, 'a'>((props, ref) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const getExcludeList = useRecoilValue(excludeCategories);
  const text =
    getExcludeList.size > 0
      ? getExcludeList.size + '개의 분류가 제외되었습니다.'
      : '먹고싶지 않은 게 있나요?';
  return (
    <>
      <Link as='button' onClick={onOpen} ref={ref} {...props}>
        {text}
      </Link>
      {
        <ChooseDrawer isOpen={isOpen} onClose={onClose} />
        // <ChooseModal isOpen={isOpen} onClose={onClose} />
        // Modal or Drawer?
      }
    </>
  );
});

export default FilterLink;
